import { Divider, FormControlLabel, ListItem, Switch } from "@mui/material";
import { t } from "i18next";
import { CU_MASK, CU_ROW_TYPES } from "../../../../utils/constants/cu";
import CoreInputField from "../../../../app/core/components/CoreInputField/CoreInputField";
import { useState } from "react";
import moment from "moment";
import CoreSelect from "../../../../app/core/components/CoreSelect/CoreSelect";

const DocField = ({ docCategory, data, dataDoc }) => {
  const [formData, setFormData] = useState(dataDoc.cu);
  const [showAllFields, setShowAllFields] = useState(false);

  const docCategoryNameSolver = () => {
    switch (docCategory) {
      case "Cu":
        return "CU - Lavoro dipendente";
      case "Id":
        return "Documento Identità";
      case "Med":
        return "E1_1 / E1_2-Spese Patologie Esenti-Spese Sanitarie";
      case "F24":
        return "Modello F24";
      default:
        return docCategory;
    }
  };

  const getMask = () => CU_MASK["default"];

  function getLabel(value, label) {
    if (value === undefined) {
      return "";
    }
    if (typeof value === "number") {
      return label.replace("{YEAR}", value);
    }
    return label.replace(
      "{YEAR}",
      value ? moment(value).year() : moment().year() - 1
    );
  }

  const gruppoCU = (gruppo) => {
    return gruppo.rows.map(
      (rigo) =>
        ((formData[rigo.key] !== 0 && !showAllFields) || showAllFields) && (
          <div>
            {rigo.type === CU_ROW_TYPES.DATA && (
              <div className="w-full">
                <CoreInputField
                  InputLabelProps={{ shrink: true }}
                  key={rigo.key}
                  value={new Date(formData[rigo.key]).getFullYear()}
                  label={rigo.label}
                  className="w-full"
                />
              </div>
            )}
            {rigo.type === CU_ROW_TYPES.CF && (
              <CoreInputField
                className=" me-8 w-full"
                InputLabelProps={{ shrink: true }}
                key={rigo.key}
                value={formData[rigo.key]}
                label={rigo.label}
              />
            )}
            {rigo.type === CU_ROW_TYPES.IMPORTO && (
              <CoreInputField
                className="me-8 w-full "
                InputLabelProps={{ shrink: true }}
                key={rigo.key}
                value={formData[rigo.key]}
                label={rigo.label}
              />
            )}
            {rigo.type === CU_ROW_TYPES.INTERO && (
              <CoreInputField
                className="me-8 w-full"
                InputLabelProps={{ shrink: true }}
                key={rigo.key}
                value={formData[rigo.key]}
                label={rigo.label}
              />
            )}
            {rigo.type === CU_ROW_TYPES.TEXT && (
              <CoreInputField
                className="me-8 w-full"
                InputLabelProps={{ shrink: true }}
                key={rigo.key}
                value={formData[rigo.key]}
                label={rigo.label}
              />
            )}
            {rigo.type === CU_ROW_TYPES.TEXTAREA && (
              <CoreInputField
                className="me-8 w-full"
                InputLabelProps={{ shrink: true }}
                type="textarea"
                key={rigo.key}
                value={formData[rigo.key]}
              />
            )}
            {rigo.type === CU_ROW_TYPES.BOOL && (
              <>
                <FormControlLabel
                  className="me-8 w-full"
                  key={rigo.key}
                  value={formData[rigo.key]}
                  control={<Switch color="primary" />}
                  label={rigo.label}
                  labelPlacement="start"
                />
              </>
            )}
            {rigo.type === CU_ROW_TYPES.OPTIONS && (
              <div className="">
                <CoreSelect
                  className="w-full me-8"
                  label={"Seleziona"}
                  key={rigo.key}
                  value={formData[rigo.key]}
                  items={rigo.options}
                />
              </div>
            )}
          </div>
        )
    );
  };

  const hasVisibleFields = (gruppo) => {
    return gruppo.rows.some((rigo) => {
      return formData[rigo.key] !== 0;
    });
  };

  return (
    <div style={{ height: "60vh" }} className="w-full p-2">
      <h3 className="pl-2">
        {docCategoryNameSolver() || t("Category") + ": N/A"}
      </h3>
      {formData && (
        <div className="p-2">
          <Divider />
          <FormControlLabel
            control={
              <Switch
                checked={showAllFields}
                onChange={() => setShowAllFields(!showAllFields)}
              />
            }
            label="Visualizza tutti i campi"
          />
        </div>
      )}
      <div
        style={{ border: "1px solid #0000001f" }}
        className="m-1 h-4/5 rounded-lg overflow-y-auto"
      >
        {formData ? (
          showAllFields ? (
            getMask(formData?.categoryId)?.map((el, idx) => (
              <div key={idx} className="flex flex-col">
                <ListItem className="flex flex-col">
                  <p className="text-black font-bold w-full break-words">
                    {getLabel(formData?.annoRiferimento, el.label)}
                  </p>

                  <p className="text-black w-full break-words">
                    {gruppoCU(el)}
                  </p>
                </ListItem>
                <Divider />
              </div>
            ))
          ) : (
            <div>
              {getMask(formData?.categoryId)?.map(
                (gruppo) =>
                  hasVisibleFields(gruppo) && (
                    <ListItem className="flex flex-col">
                      <p className="text-black font-bold w-full break-words">
                        {getLabel(formData?.annoRiferimento, gruppo.label)}
                      </p>
                      <p className="text-black w-full break-words">
                        {gruppoCU(gruppo)}
                      </p>
                    </ListItem>
                  )
              )}
            </div>
          )
        ) : (
          data?.map((item, idx) => (
            <div key={idx}>
              <ListItem className="flex">
                <p className="text-black font-bold w-1/2 break-words">
                  {item["fieldName"]?.replaceAll("_", " ")}
                </p>

                <p className="text-black w-1/2 break-words text-right">
                  {typeof item["fieldValue"] === "string" &&
                  item["fieldValue"]?.includes("T00:00:00")
                    ? item["fieldValue"].substring(0, 10)
                    : item["fieldValue"]}
                </p>
              </ListItem>
              <Divider />
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default DocField;
